interface LogoProps {
  width?: number | string;
  height?: number | string;
}

export const Vodafone = ({ width = 28, height = 28 }: LogoProps) => (
  <svg width={width} height={height} viewBox="0 0 28 28">
    <path
      d="M28.0004 14C28.0004 21.7318 21.7347 28 14.0029 28C6.27115 28 0.00292969 21.7318 0.00292969 14C0.00292969 6.26824 6.27115 0 14.0029 0C21.7347 0 28.0004 6.26824 28.0004 14ZM14.1135 21.8063C18.8616 21.7909 21.6703 17.8916 21.66 14.3317C21.6472 10.7745 19.7129 8.20242 15.4509 7.16329C15.4407 7.11953 15.433 7.02434 15.433 6.93438C15.4253 4.24651 17.4521 1.87502 19.9985 1.34774C19.7593 1.26543 19.3658 1.23462 18.9902 1.23462C16.0786 1.24491 12.866 2.49238 10.5203 4.43175C8.11793 6.42257 6.23514 9.77917 6.24802 13.2644C6.26601 18.5372 10.2682 21.8194 14.1135 21.8063Z"
      fill="#4C635A"
    />
  </svg>
);
